import { render, staticRenderFns } from "./nested_groups_projects_list.vue?vue&type=template&id=ffdfbf2c"
import script from "./nested_groups_projects_list.vue?vue&type=script&lang=js"
export * from "./nested_groups_projects_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports